import axios from 'axios';
import { API_URL } from './config';
import authHeader from './auth-header';

const BASE = API_URL.replace('/auth/', '/mail/');

const send = (data) => {
  // Accepts either JSON or FormData. If FormData, let the browser set the multipart boundary.
  const isForm = typeof FormData !== 'undefined' && data instanceof FormData;
  const headers = { ...authHeader() };
  if (isForm) {
    delete headers['Content-Type'];
  } else {
    headers['Content-Type'] = 'application/json';
  }
  return axios.post(`${BASE}send`, data, { headers });
};

const MailService = { send };
export default MailService;
